import { render, staticRenderFns } from "./Dropdown2_copy.vue?vue&type=template&id=75a906fe&scoped=true&"
import script from "./Dropdown2_copy.vue?vue&type=script&lang=js&"
export * from "./Dropdown2_copy.vue?vue&type=script&lang=js&"
import style0 from "./Dropdown2_copy.vue?vue&type=style&index=0&id=75a906fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a906fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
